export enum DnsFailureClass {
  Retryable = "retryable",
  RetryableOtherInput = "retryable_other_input",
  ManualRequired = "manual_required",
  NeedsDifferentActor = "needs_different_actor",
}
